'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {LoginCtrl} from "./loginctrl.js";
EwSiteApp.controller('LoginCtrl', ["$scope", "jsDataService", LoginCtrl]);